import { render } from "./ReenviarEmailLink.vue?vue&type=template&id=563c39b6&scoped=true"
import script from "./ReenviarEmailLink.vue?vue&type=script&lang=js"
export * from "./ReenviarEmailLink.vue?vue&type=script&lang=js"

import "./ReenviarEmailLink.vue?vue&type=style&index=0&id=563c39b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563c39b6"]])

export default __exports__